import {useCallback, useEffect, useState} from 'react'
import {checkCitysparkOauthStatus} from '../utils/auth-helpers'
import {useVoterContext} from '../context/voter'
// Types
import type {CitysparkUser} from '../types/auth'
import type {Voter} from '../types/voter'

export type {CitysparkUser}

export interface CombinedAuthStatus {
  voter: Voter | null
  isLoadingVoter: boolean
  isFullyAuthenticated: boolean
}

export const useCombinedAuthStatus = (): CombinedAuthStatus => {
  const {voter, isLoadingVoter} = useVoterContext()
  const [citysparkUser, setCitysparkUser] = useState<CitysparkUser | null>(null)

  const refreshCitysparkStatus = useCallback(async () => {
    const user = await checkCitysparkOauthStatus()
    setCitysparkUser(user as CitysparkUser | null)
  }, [])

  useEffect(() => {
    refreshCitysparkStatus()
  }, [refreshCitysparkStatus])

  useEffect(() => {
    const handleWindowFocus = () => {
      refreshCitysparkStatus()
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return
      refreshCitysparkStatus()
    }

    window.addEventListener('focus', handleWindowFocus)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.removeEventListener('focus', handleWindowFocus)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [refreshCitysparkStatus])

  return {
    voter,
    isLoadingVoter,
    isFullyAuthenticated: !!voter && !!citysparkUser,
  }
}
